import React from 'react';
import { Link } from 'react-router';
import { C } from './publicStyles';

const linkStyle = { color: C.muted, fontSize: 13, textDecoration: 'none' };

export default function PublicFooter() {
  return (
    <footer style={{ borderTop: `1px solid ${C.border}`, marginTop: 'auto' }}>
      <div style={{
        maxWidth: 1080, margin: '0 auto', padding: '28px 24px',
        display: 'flex', alignItems: 'center', gap: 20, flexWrap: 'wrap',
      }}>
        <span style={{ color: C.faint, fontSize: 13 }}>© 2026 CrimsonScan</span>
        <div style={{ flex: 1 }} />
        <a href="mailto:support@crimsonscan.com" style={linkStyle}>support@crimsonscan.com</a>
        <Link to="/enroll" style={linkStyle}>Talk to us</Link>
        <Link to="/docs/terms" style={linkStyle}>Terms</Link>
        <Link to="/docs/privacy" style={linkStyle}>Privacy</Link>
        <Link to="/docs/acceptable-use" style={linkStyle}>Acceptable Use</Link>
      </div>
    </footer>
  );
}
